import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { Checkbox, Modal } from 'antd';

import * as actions from '../../actions';

const { confirm } = Modal;

const propTypes = {
  // planId prop is used in withProps HOC
  // eslint-disable-next-line react/no-unused-prop-types
  planId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

const MetaCheckbox = ({ name, checked, onChange }) => (
  <Checkbox name={name} id={name} checked={checked} onChange={onChange} />
);

MetaCheckbox.propTypes = propTypes;

const CONFIRMATION_LABELS = {
  isDirectDebitCancelled: 'DD Cancelled',
  isRefunded: 'Refunded',
};

export default compose(
  connect(
    null,
    {
      updateCancellationMeta: actions.updateCancellationMeta,
    },
  ),
  withProps(({ updateCancellationMeta, planId }) => ({
    onChange: ({ target: { name, checked } }) =>
      confirm({
        title: `Plan #${planId} cancellation meta change`,
        content: (
          <span>
            Do you want to <b>{checked ? 'check' : 'uncheck'}</b>{' '}
            {CONFIRMATION_LABELS[name]}?
          </span>
        ),
        onOk() {
          return updateCancellationMeta(name, checked, planId);
        },
      }),
  })),
)(MetaCheckbox);
